import type { CSSProperties } from "react"
import { useLanguage } from "../hooks/useLanguage"
import { ArrowRight, Check } from "./icons"

// Pixels decorativos: posição, tamanho, cor e (nos que piscam) atraso
const pixels: { pos: CSSProperties; size: number; radius: number; color: string; opacity?: number; delay?: string }[] = [
  { pos: { left: "9%", top: 112 }, size: 12, radius: 3, color: "#6E4BFF", delay: "0s" },
  { pos: { left: "15%", top: 364 }, size: 8, radius: 2, color: "#A893FF" },
  { pos: { left: "6%", top: 560 }, size: 8, radius: 2, color: "#0B0D12", opacity: 0.85 },
  { pos: { right: "8%", top: 168 }, size: 14, radius: 3, color: "#6E4BFF", delay: "1.4s" },
  { pos: { right: "14%", top: 448 }, size: 8, radius: 2, color: "#A893FF" },
  { pos: { right: "5%", top: 616 }, size: 10, radius: 2, color: "#6E4BFF", delay: "2.4s" },
]

export default function Hero() {
  const { t } = useLanguage()
  const h = t.hero

  return (
    <div className="relative overflow-hidden">
      <div aria-hidden="true" className="gms-dots absolute inset-0" />
      <div aria-hidden="true" className="gms-deco pointer-events-none absolute inset-0">
        {pixels.map(({ pos, size, radius, color, opacity, delay }, i) => (
          <span
            key={i}
            className={delay ? "gms-twinkle" : undefined}
            style={{ position: "absolute", ...pos, width: size, height: size, borderRadius: radius, background: color, opacity, animationDelay: delay }}
          />
        ))}
      </div>

      <section className="relative mx-auto flex max-w-gms flex-col items-center px-gutter pb-2 pt-[clamp(56px,7.5vw,112px)] text-center">
        <div className="gms-pill inline-flex items-center gap-[10px] rounded-full border border-gms-line bg-white px-4 py-2 font-mono text-[13px] text-gms-muted">
          <span aria-hidden="true" className="h-2 w-2 rounded-[2px] bg-gms-accent" />
          {h.eyebrow}
        </div>

        <h1 className="mt-7 max-w-[1120px] text-h1 font-semibold leading-[0.95] tracking-[-0.05em] [text-wrap:balance]">
          {h.titleStart}
          <span className="gms-highlight">{h.titleHighlight}</span>{" "}
          <span className="text-gms-faint">{h.titleEnd}</span>
        </h1>

        <p className="mt-7 max-w-[680px] text-lead leading-[1.55] text-gms-muted [text-wrap:pretty]">{h.lead}</p>

        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <a
            href="#contato"
            className="gms-btn inline-flex min-h-[58px] items-center gap-[10px] rounded-full bg-gms-accent px-[30px] text-[17px] font-semibold text-white no-underline shadow-[0_14px_30px_-14px_rgba(110,75,255,0.55)] hover:text-white"
          >
            {h.ctaPrimary}
            <ArrowRight />
          </a>
          <a
            href="#servicos"
            className="gms-btn inline-flex min-h-[58px] items-center rounded-full border border-gms-line-2 bg-white px-7 text-[17px] font-semibold text-gms-ink no-underline"
          >
            {h.ctaSecondary}
          </a>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-x-7 gap-y-[10px] text-[15px] text-gms-muted">
          {h.checks.map((item) => (
            <li key={item} className="inline-flex items-center gap-2">
              <Check size={16} className="text-gms-accent" />
              {item}
            </li>
          ))}
        </ul>
      </section>
    </div>
  )
}
